import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MustMatch } from '../application/application.business.info';

export class BankInfoData {

    public form: FormGroup;

    constructor(private formBuilder: FormBuilder) {
        this.form = this.formBuilder.group({
            accountName: ['',Validators.required],
            accountNumber: ['',Validators.required],
            accountNumberConfirm: ['',Validators.required],
            accountRoutingNumber: ['',Validators.required],
            accountType: ['',Validators.required],
            bankName: ['',Validators.required],
            city: ['',Validators.required],
            state: ['',Validators.required]
        }, {
            validator: MustMatch('accountNumber', 'accountNumberConfirm')
        });
    }

    decode(data: any) {
        this.form.controls.accountName.setValue(data.accountName);
        this.form.controls.accountNumber.setValue(data.accountNumber);
        this.form.controls.accountNumberConfirm.setValue(data.accountNumberConfirm);
        this.form.controls.accountRoutingNumber.setValue(data.accountRoutingNumber);
        this.form.controls.accountType.setValue(data.accountType);
        this.form.controls.bankName.setValue(data.bankName);
        this.form.controls.city.setValue(data.city);
        this.form.controls.state.setValue(data.state);
    }

    encode(): any {
        return {
            accountName: this.form.controls.accountName.value,
            accountNumber: this.form.controls.accountNumber.value,
            accountNumberConfirm: this.form.controls.accountNumberConfirm.value,
            accountRoutingNumber: this.form.controls.accountRoutingNumber.value,
            accountType: this.form.controls.accountType.value,
            bankName: this.form.controls.bankName.value,
            city: this.form.controls.city.value,
            state: this.form.controls.state.value
        };
    }
}
